import { Link, useParams } from 'react-router-dom';
import { LOCATIONS } from './constants';
import { LocationsMap } from './LocationsMap';
import React, { useState } from 'react';
import { AudioPlayer } from './AudioPlayer';
import { Captions, Fullscreen, Zoom } from 'yet-another-react-lightbox/plugins';
import Lightbox from 'yet-another-react-lightbox';

export const Location = () => {
    const [galleryOpen, setGalleryOpen] = useState(false);
    const [showDescription, setShowDescription] = useState(false);
    let { locationNum } = useParams();
    const locationIndex = locationNum - 1;
    const location = LOCATIONS[locationIndex];

    if (!location) {
        return <h3>Location not found</h3>;
    }

    const { title, address, address2, description, lat, lng, dates, imgCredit } = location;

    const prevLink = locationIndex > 0 ? (
        <Link className="float-start mb-3" to={`/location/${locationIndex}`}>
            <button className="btn btn-primary"><i className="bi bi-arrow-left-short"></i> Previous Location</button>
        </Link>
    ) : null;
    const nextLink = locationIndex < LOCATIONS.length - 1 ? (
        <Link className="float-end mb-3" to={`/location/${locationIndex + 2}`}>
            <button className="btn btn-primary">Next Location <i className="bi bi-arrow-right-short"></i></button>
        </Link>
    ) : null;

    const slide = {
        title,
        description: imgCredit,
        src: `./img/locations/Location_${locationNum}_fullsize.webp`,
        thumbnail: `./img/locations/Location_${locationNum}_fullsize-tn.webp`,
    };

    return (
        <>
            <Lightbox
                className="lightbox"
                carousel={{
                    finite: true,
                }}
                // index={index}
                open={galleryOpen}
                close={() => setGalleryOpen(false)}
                plugins={[Captions, Fullscreen, Zoom]}
                slides={[slide]}

                render={{
                    buttonPrev: () => null,
                    buttonNext: () => null,
                }}
            />
            <div className="feature">
                <div className="container">
                    <AudioPlayer location={location}/>
                    <h3><b>{title}</b></h3>
                    <h4>{address}</h4>
                    <h4>{address2}</h4>
                    <p>
                        Location #{locationNum} of 19 &nbsp;
                        <a href={`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`} target="_blank" rel="noreferrer" className="me-2">Map</a>
                        <a href={`https://www.google.com/maps/dir/to/${lat},${lng}`} target="_blank" rel="noreferrer">Directions</a> <i className="bi bi-box-arrow-up-right"></i>
                    </p>

                    <div className={`description-container ${showDescription ? 'expanded' : ''}`}>
                        <img
                            className={"img-thumbnail w-25"}
                            onClick={() => {
                                setGalleryOpen(true);
                            }}
                            src={`./img/locations/Location_${locationNum}_fullsize-tn.webp`}
                            align={"right"}
                            alt={`Location #${locationNum} of 19`}
                        />
                        {
                            dates.map((date) => {
                                return <h5 key={date}><em>{date}</em></h5>;
                            })
                        }
                        {description}
                    </div>
                    <button className="btn btn-primary mt-2 mb-3" onClick={() => {
                        setShowDescription(!showDescription);
                    }}>{showDescription ? 'Hide Description' : 'Show More'}</button>

                    <p>{prevLink}{prevLink && nextLink ? ' ' : ''}{nextLink}</p>
                </div>
            </div>
            <div className="feature">
                <div className="row map-row">
                    <div className="col map-col">
                        <LocationsMap locationIndex={locationIndex}/>
                    </div>
                </div>
            </div>
            <div className="feature">
                <div className="container">
                    <p>{prevLink}{prevLink && nextLink ? ' ' : ''}{nextLink}</p>
                </div>
            </div>
            <br/><br/>
        </>
    );
};
